import {useEffect} from 'react';
import {Navigate, useLocation, useNavigate} from "react-router-dom";
import LoadingScreen from "../LoadingScreen";
import {PATH_AUTH, PATH_DASHBOARD} from "../../routes/paths";
import {useAuthenticationContext} from '../../contexts/authentication'

export const Public = (Component) => (props) => {
    const {customer, status} = useAuthenticationContext();
    const navigate = useNavigate();

    useEffect(() => {
        if (customer.isLoggedIn()) {
            navigate('/');
        }
    }, [customer, navigate]);

    if (status.loggingOut) {
        return <LoadingScreen/>
    }

    return <Component {...props}/>;
}

export default Public;
